export enum ParameterTypeE {
  SMS = 'sms',
  RUBEUS = 'rubeus',
  MENTION = 'mention',
  TELEPHONY = 'telephony',
  ATTEMPTS_FEEDBACK = 'attemptsFeedback',
  CONTACT_LOYALTY = 'contact_loyalty',
  TRANSFER_OF_SERVICE = 'transfer_of_service',
  MANDATORY_TABULATION = 'mandatory_tabulation',
  ALLOW_MULTIPLE_TABULATIONS = 'allow_multiple_tabulations',
  ATTENDANCE_EXPORT = 'attendance_export',
  NOTE = 'notes',
  ALLOW_AGENTS_TO_OPEN_TICKETS = 'allow_agents_to_open_tickets',
  AI_CONNECTORS = 'ai_connectors',
  AWAY = 'away',
  BLOCK = 'block',
  API_CHAT_TIMEOUT = 'api_chat_timeout',
  BLOCK_SELF_BULK_TRANSFER = 'block_self_bulk_transfer',
  AUTO_PAUSE_TABULATION = 'auto_pause_tabulation',
  INCOMING_CALL_TEAM = 'incoming_call_team',
  EXTERNAL_CONNECTOR = 'external_connector',
}

/** Region the customer's outbound integrations leave from ('default' = the platform's own region). */
export enum ParameterEgressRegionE {
  DEFAULT = 'default',
  SA_EAST_1 = 'sa-east-1',
}

export enum ParameterMentionTypeE {
  MENTION_TYPE_ALL = 'mention_type_all',
  MENTION_TYPE_TEAM = 'mention_type_team',
}

export enum ParameterContactLoyaltyTypeE {
  TRANSFER_TO_SUPERVISOR = 'transfer_to_supervisor',
  TRANSFER_TO_TEAM = 'transfer_to_team',
  TRANSFER_TO_FLOW = 'transfer_to_flow',
}

export enum ParameterTransferOfSeviceE {
  ALL = 'all',
  ONLY_FROM_TEAM = 'only_from_team',
}

export enum ParameterMandatoryTabulationE {
  TELEPHONY = 'telephony',
  MESSAGING = 'messaging',
  MESSAGING_AND_TELEPHONY = 'messaging_and_telephony',
}

export enum ParameterEmailTitleTypeE {
  CHAT_FINISHED_DATE = 'chat_finished_date',
  CUSTOM = 'custom',
}

export enum ParameterNoteVisibilityTypeE {
  SYSTEM_DEFAULT = 'system_default',
  OWNER_NOTE = 'owner_note',
}
